export enum CustomizationLevel {
  All = 'CustomizationLevelAll',
  Group = 'CustomizationLevelGroup',
  Individual = 'IndividualLevelGroup',
}
